import { render, staticRenderFns } from "./Dashboard_GS.vue?vue&type=template&id=1bd295f2&scoped=true&"
import script from "./Dashboard_GS.vue?vue&type=script&lang=js&"
export * from "./Dashboard_GS.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard_GS.vue?vue&type=style&index=0&id=1bd295f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd295f2",
  null
  
)

export default component.exports